<div class="location-filter mt-16 flex-column">
  <div class="flex-row">
    <div class="flex-1">
      <label class="label">Organization Tag</label>
      @for (kv of model.tags; track kv) {
        <span class="tag">{{ kv.tag }}: {{ kv.value }}</span>
      }
      <span class="total"> ({{ total }} organizations)</span>
    </div>
    <div class="actions text-right">
      <lib-button variant="icon" color="primary" icon="delete" tooltip="Delete organization tag filter" (buttonClick)="onDelete()"></lib-button>
    </div>
  </div>

  <lib-data-table
    [data]="rows"
    [columns]="columns"
    [showFilter]="false"
    [showPaginator]="false"
    [fullWidth]="true">
  </lib-data-table>

</div>

